import {RouteConfig} from 'vue-router';
import AuthPage from '@/views/auth/AuthPage.vue';
import RegisterPage from '@/views/auth/RegisterPage.vue';
import ForgotPasswordPage from '@/views/auth/ForgotPasswordPage.vue';
import UpdatePasswordPage from '@/views/auth/UpdatePasswordPage.vue';
import ConfirmUserPage from '@/views/auth/ConfirmUserPage.vue';
import AcceptTermsAndPolicies from '@/views/auth/AcceptTermsAndPolicies.vue';

export const authRoutes: RouteConfig[] = [
  {
    path: '',
    component: AuthPage,
  },
  {
    path: 'register',
    name: 'register',
    component: RegisterPage,
  },
  {
    path: 'accept-terms-and-conditions',
    name: 'acceptTermsAndConditions',
    component: AcceptTermsAndPolicies,
    props: true,
  },
  {
    path: 'forgot',
    name: 'forgotPassword',
    component: ForgotPasswordPage,
  },
  {
    path: 'update-password/:token',
    name: 'updatePassword',
    component: UpdatePasswordPage,
  },
  {
    path: 'verify/:token',
    name: 'confirmUser',
    component: ConfirmUserPage
  }
];

